import gql from 'graphql-tag';

// eslint-disable-next-line import/prefer-default-export
export const fetchCatalogItemsQuery = gql`
  query SearchCatalogItems
  (
    $catalog: uuid!,
    $limit: Int!,
    $offset: Int!, 
    $keyword: String, 
    $published_at_is_null: Boolean,
    $price_gte: numeric,
    $price_lte: numeric,
  ) {
    search_item_aggregate(
      where: {
        _and: {
          catalog: { id: { _eq: $catalog } },
          price: { _gte: $price_gte, _lte: $price_lte}
        }
      }
      args: { search: $keyword }
    ) {
      aggregate {
        count
      }
    }
    search_item(
      where: {
        _and: {
          catalog: { id: { _eq: $catalog } },
          price: { _gte: $price_gte, _lte: $price_lte}
        }
      }
      args: { search: $keyword }
      limit: $limit
      offset: $offset
    ) {
      id
      sku
      name
      description
      currency
      price
      uom
      manufacturer
      manufacturer_partnumber
      image
    }
  }
`;


export const MRO_CATALOG_GET_PRODUCT_ITEM = gql`
  query CatalogItemById($productId: uuid!) {
    item_by_pk(id: $productId) {
      id
      sku
      code
      name
      description
      catalog_id
      currency
      price
      uom
      manufacturer
      manufacturer_partnumber
      has_stock
      is_active
      category_id
      taxonomy_category {
        mdm_code
        mdm_name
      }
      noun
      modifier
      item_attribute_values {
        item_id
        attribute_id
        mdm_value
        taxonomy_attribute {
          mdm_code
          mdm_name
          mdm_order
          is_required
        }
      }
      technical_specification
      image
    }
  }
`;

export const MRO_SEARCH_ITEMS = gql`
  query MRO_SEARCH_ITEM(
    $limit: Int!,
    $offset: Int!, 
    $keywords: String
  ){
    search_itemsearch_aggregate(args: { search: $keywords}) {
      aggregate {
        count
      }
    }
    search_itemsearch
    (
      args: { search: $keywords }
      limit: $limit
      offset: $offset
      order_by: {item_match: desc}
    ){
      id
      code
      name
      description
      currency
      price
      catalog_id
      category {
        mdm_code
        mdm_name
      }
      catalog {
        id
        name
        organization {
          id
          name
        }
      }
      item_match
    }
  }`;


export const MRO_INSERT_INFORMATION_REQUEST = gql`mutation MRO_INSERT_INFORMATION_REQUEST($data: [information_request_insert_input!]!) {
  insert_information_request(objects: $data) {
    returning {
      id
    }
  }
}`;

export const MRO_CATALOG_BY_PK = gql`query getCatalogByPk($id: uuid!){
  catalog_by_pk(id: $id) {
    id
    name
    organization {
      id
      name
    }
  }
}`;

export const MRO_SEARCH_INFORMATION_REQUESTS_QUERY = gql`
  query MRO_SEARCH_INFORMATION_REQUESTS(
    $limit: Int!, 
    $offset: Int!, 
    $order_by: [information_request_order_by!]!,
    $keywords: String
  ) {
    information_request_aggregate {
      aggregate {
        count
      }
    }
    information_request(
      limit: $limit,
      offset: $offset,
      order_by: $order_by,
      where: {
        _or: [
          {
            number: { _like: $keywords }
          },
          {
            name: { _like: $keywords }
          },
          {
            search_text: { _like: $keywords }
          },
          {
            supplier_responses: {
              items: {
                catalog_item: {
                  name: {
                    _like: $keywords
                  }
                }
              }
            }
          }
        ]
      }
    ) {
      id
      number
      name
      close_date
      created_at
      organization {
        id
        name
      }
      supplier_responses_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;

export const MRO_GET_INFORMATION_REQUEST_QUERY = gql`query MRO_GET_INFORMATION_REQUEST_QUERY($id: uuid!) {
  information_request_by_pk(id: $id) {
    id
    number
    name
    search_text
    requested_quantity
    requested_uom
    expected_delivery_date
    expected_delivery_location
    override_expected_delivery_date
    require_stock_confirmation
    require_delivery_availability
    close_date
    message
    organization {
      id
      name
    }
    supplier_responses {
      id
      number
      answered_at
      readed_at
      created_at
      supplier_organization {
        id
        name
        contact_name
        contact_email
      }
      items {
        id
        price
        currency
        has_stock
        has_stock_alternative
        stock_quantity
        stock_uom
        stock_observations
        has_delivery_availability
        has_delivery_alternative
        delivery_date
        delivery_observations
        score
        average
        created_at
        updated_at
        catalog_item {
          id
          description
          name
          price
          currency
        }
      }
    }
  }
}
`;

export const MRO_GET_COMPARER_RESPONSES = gql`query MRO_GET_COMPARER_RESPONSES (
  $id: uuid, 
  $require_stock: Boolean,
  $require_delivery_availability: Boolean
){
  information_response(where: {
      information_request_id: { _eq: $id }
      answered_at: {
        _is_null: false
      },
      items: {
        has_stock: {
          _is_null: $require_stock
        },
        has_delivery_alternative: {
          _is_null: $require_delivery_availability
        }
      }
    }
    order_by: [
      { answered_at: asc }
    ]
  )
  {
    id
    number
    answered_at
    readed_at
    created_at
    supplier_organization {
      id
      name
      tax_id
    }
    items {
      id
      price
      currency
      has_stock
      has_stock_alternative
      stock_quantity
      stock_uom
      stock_observations
      has_delivery_availability
      has_delivery_alternative
      delivery_date
      delivery_observations
      delivery_location
      score
      average
      created_at
      updated_at
      catalog_item {
        id
        description
        name
        price
        currency
      }
    }
  }
}`;



// WEBPACK FOOTER //
// ./src/store/graphql/queries/cat4mro.js